// iOS Inset-Grouped-Listen (Overnight-Redesign): Gruppen-Titel in Sentence-Case (13px, sekundär),
// abgerundete Gruppe auf der jeweils helleren Fläche, Hairline-Separatoren eingerückt.
//
// <InsetGroup title="Verkäufe" aside="12" footer="Hinweistext">
//   <InsetRow title="…" subtitle="…" value="…" onClick={…} />
// </InsetGroup>

export function InsetGroup({ title, aside, footer, children, className = '', surface = 'L1', testId }) {
  const bg = surface === 'L2'
    ? 'bg-[var(--bg-L1)] dark:bg-[var(--bg-L2)]'
    : surface === 'L3'
      ? 'bg-[var(--bg-L1)] dark:bg-[var(--bg-L3)]'
      : 'bg-[var(--bg-L1)]';
  return (
    <section data-testid={testId} className={className}>
      {(title || aside != null) && (
        <div className="flex items-end justify-between px-4 pb-1.5 text-[13px] text-[var(--label-secondary)]">
          <span>{title}</span>
          {aside != null && <span className="num">{aside}</span>}
        </div>
      )}
      <div className={`overflow-hidden rounded-[16px] ${bg}`}>{children}</div>
      {footer && <p className="px-4 pt-1.5 text-[13px] leading-snug text-[var(--label-secondary)]">{footer}</p>}
    </section>
  );
}

// Eine Zeile. leading = Icon/Thumbnail (44pt-Spalte), separator wird ab der Text-Spalte gezogen.
export function InsetRow({
  leading, title, subtitle, value, valueSub, trailing, onClick, first = false, testId, valueClassName = '',
  titleClassName = '', as, minHeight = 52, ...rest
}) {
  const Tag = as || (onClick ? 'button' : 'div');
  return (
    <Tag
      type={Tag === 'button' ? 'button' : undefined}
      data-testid={testId}
      onClick={onClick}
      className={`flex w-full items-center gap-3 pl-4 pr-3 text-left ${onClick ? 'active:bg-[var(--fill-quaternary)]' : ''}`}
      style={{ minHeight, transition: onClick ? 'background-color 120ms var(--ease-out-ios)' : undefined }}
      {...rest}
    >
      {leading}
      <div
        className={`flex min-w-0 flex-1 items-center gap-2 self-stretch py-2.5 ${first ? '' : 'border-t border-[var(--separator)]'}`}
        style={{ minHeight }}
      >
        <div className="min-w-0 flex-1">
          <p className={`text-[17px] leading-[1.25] ${titleClassName}`}>{title}</p>
          {subtitle && <div className="mt-0.5 text-[13px] text-[var(--label-secondary)]">{subtitle}</div>}
        </div>
        {(value != null || valueSub) && (
          <div className="shrink-0 text-right">
            {value != null && <div className={`num text-[17px] ${valueClassName}`}>{value}</div>}
            {valueSub && <div className="num text-[13px] text-[var(--label-secondary)]">{valueSub}</div>}
          </div>
        )}
        {trailing}
      </div>
    </Tag>
  );
}
